// routes
import Router from "./routes";
// theme
import ThemeConfig from "./theme";
// components
import { AxiosInterceptor } from "./utils/axios";
import ScrollToTop from "./components/ScrollToTop";
import FirebaseInit from "./components/FirebaseInit";
import SessionTimeout from "./components/SessionTimeout";
import PendingSales from "./components/_dashboard/sale/PendingSales";
import ThemePrimaryColor from "./components/ThemePrimaryColor";
import NotistackProvider from "./components/NotistackProvider";
import BarcodeListener from "./components/BarcodeListener";

// ----------------------------------------------------------------------

export default function App() {
  return (
    <ThemeConfig>
      <ThemePrimaryColor>
        <NotistackProvider>
          <AxiosInterceptor>
            <FirebaseInit />
            <SessionTimeout />
            <PendingSales />
            <ScrollToTop />
            <BarcodeListener />
            <Router />
          </AxiosInterceptor>
        </NotistackProvider>
      </ThemePrimaryColor>
    </ThemeConfig>
  );
}
